import { ruleCreateToDto, ruleFromDto, ruleUpdateToDto } from "./rulesMapper";

export const ruleFieldFromDto = (dto = {}) => ({
  id: dto.id,
  code: dto.code,
  label: dto.label,
  fieldType: dto.field_type,
  options: dto.options,
});

export const ruleGroupFromDto = (dto = {}, _is_root = true) => ({
  id: dto.id,
  operator: dto.operator,
  rules: dto.rules?.map(ruleFromDto),
  children: dto.children?.map(child => ruleGroupFromDto(child, false)),
  active: dto.active,
  ...(_is_root && { // Se incluyen estos campos únicamente en el nodo raíz, no en los hijos
    agreement: dto.agreement,
    agreementPlan: dto.agreement_plan,
    rate: dto.rate,
  }),
});

const ruleGroupToDto = (data = {}, { mode, isRoot }) => ({
  ...(mode === 'update' && !isRoot && { id: data.id }), // El id solo se envía en update y para grupos hijos
  operator: data.operator,
  rules: data.rules?.map(mode === 'create' ? ruleCreateToDto : ruleUpdateToDto), // Se pasa el map de rules de acuerdo al modo
  children: data.children?.map((child) => ruleGroupToDto(child, { mode, isRoot: false })),
})

export const ruleGroupCreateToDto = (data = {}) => ({
  ...ruleGroupToDto(data, { mode: 'create', isRoot: true }),
  agreement: data.agreementId,
  agreement_plan: data.agreementPlanId,
  rate: data.rateId,
});

export const ruleGroupUpdateToDto = (data = {}) => ruleGroupToDto(data, { mode: 'update', isRoot: true });
